<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-button type="primary" @click="showAddRecord = true"
                    >添加导出记录</el-button
                >
                <el-button type="primary" @click="onSubmit"
                    >刷新列表按钮</el-button
                >
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
            @sort-change="handleSortChange"
            style="width: 100%;"
        >
            <el-table-column label="ID" width="80" align="center" fixed>
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="开始日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.start_date || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="结束日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.end_date || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="备注" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.remark || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="数据状态" min-width="150" align="center">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.status == '-1'"
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        >{{
                            scope.row.export_err_message || "导出失败"
                        }}</el-button
                    >
                    <el-button
                        v-if="scope.row.status == '0'"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        >待导出</el-button
                    >
                    <el-button
                        v-if="scope.row.status == '1'"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        >导出中</el-button
                    >
                    <el-button
                        v-if="scope.row.status == '2'"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        >完成导出</el-button
                    >
                </template>
            </el-table-column>
            <el-table-column label="操作" width="260" fixed="right">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.status == '2'"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        @click="downFile(scope.row.export_path)"
                        size="mini"
                        >下载</el-button
                    >
                    <el-button
                        @click="delete_file(scope.row, 1)"
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <exportRecord
            :visible="showAddRecord"
            :title="'添加导出记录'"
            @success-record="successllback"
            @close-callback="closeCllback"
        ></exportRecord>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; padding-bottom: 30px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
    </div>
</template>

<script>
import * as api from "@/api/statistics/statistics";
import Upload from "./newupload";
import exportRecord from "./exportRecord.vue";
import DownloadList from "../downloadList";
import DownloadView from "../downloadView";
import BidList from "../bidList.vue";
import AddPpc from "../addPpc";
import { downLoadFilePy } from "../../../utils/method";
import { downloadFileUrl } from "@/utils/method";

let timer = null;
export default {
    components: {
        Upload,
        DownloadList,
        DownloadView,
        AddPpc,
        BidList,
        exportRecord
    },
    data() {
        return {
            showAddRecord: false,
            currentId: "",
            tableHeight: null,
            ctrl: {
                DownloadListDialogVisible: false,
                addPpcDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false
            },
            typeArr: [
                {
                    index: 1,
                    title: "广告层面"
                },
                {
                    index: 2,
                    title: "逻辑层面"
                }
            ],
            us_arr: [
                {
                    us: "us",
                    title: "美国"
                },
                {
                    us: "uk",
                    title: "英国"
                },
                {
                    us: "de",
                    title: "德国"
                }
            ],
            query: {
                page: 1,
                limit: 20,
                total: 0,
                ad_portfolio_name_id: ""
            },
            record_id: 0,
            activeName: "antiInternal",
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: []
        };
    },
    created() {
        this.query.ad_portfolio_name_id = this.$route.query.ad_portfolio_name_id;
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 710 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        710 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
        this.getList();
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    destroyed() {
        clearInterval(timer);
    },
    methods: {
        getList() {
            this.loading = true;
            api.period_seed_word_show({
                page: this.query.page,
                limit: this.query.limit,
                state: this.$route.query.state,
                asin: this.$route.query.asin
            })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data.detail_list;
                        this.list.forEach(item => {
                            if (
                                item.operating === 1 ||
                                item.optimization === 1
                            ) {
                                this.parseStatusList.push(item.id);
                                item.operating === 1 &&
                                    this.get_ad_parse_status();
                                item.optimization === 1 &&
                                    this.get_parse_status();
                            }
                        });

                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        antiInternalBidding() {
            this.disabled = true;
            api.listing_prevent_internal_competition({
                asin: this.query.asin
            })
                .then(res => {
                    this.disabled = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message:
                                "正在分析数据，后续可通过下载列表进行下载文件！"
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        brandBidding(data) {
            this.listDisabled = true;
            api.check_brand_ppc({
                asin: this.query.asin,
                record_id: data.id
            })
                .then(res => {
                    this.listDisabled = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message:
                                "正在分析数据，后续可通过下载列表进行下载文件！"
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.listDisabled = false;
                });
        },
        handleSortChange(val) {
            if (val.order == "ascending") {
                this.query.desc = "desc";
                this.query.order = val.prop;
            } else if (val.order == "descending") {
                this.query.desc = "asc";
                this.query.order = val.prop;
            }
            this.getList();
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList();
            });
        },
        //重置
        onReset() {
            this.query.project_name = "";
            this.query.state = "";
            this.query.order = "";
            this.query.desc = "";
            this.query.page = 1;
            this.getList();
        },
        //查询
        onSubmit() {
            this.getList();
        },
        change() {
            this.getList();
        },
        clearValue() {
            this.query.state = "";
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true;
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true;
            this.$nextTick(() => {
                this.$refs[this.activeName].getList();
            });
        },
        // bid记录列表
        openBidList(data) {
            console.log("data", data);
            this.currentId = data.id;
            this.ctrl.bidDialogVisible = true;
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm("是否重新运行解析任务", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                });
            }
            console.log("cc");
            let list = JSON.parse(JSON.stringify(this.list));
            api.getAdBetterFile({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id);
                list[index].status = 1;
                this.list = list;
            });
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: "error",
                    message: "无法下载！"
                });
            }
            downLoadFilePy(path, "种子词数据");
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id;
            this.ctrl.addPpcDialogVisible = true;
        },
        //删除
        delete_file(data) {
            this.$confirm(`确定要删除这条数据吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.period_seed_keyword_record_delete({
                        id: data.id,
                        state: this.$route.query.state,
                        parent_asin: this.$route.query.asin
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(res => {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        });
                })
                .catch(() => {});
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.showAddRecord = false;
            isshow == true && this.getList();
        },
        // 关闭弹窗回调
        successllback(data = {}) {
            const loading = this.$loading({
                lock: true,
                text: "上传中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            api.seed_keyword_file_export_period({
                ...data,
                state: this.$route.query.state,
                asin: this.$route.query.asin,
                ad_portfolio_name_id: this.$route.query.ad_portfolio_name_id
            })
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "添加成功",
                            type: "success"
                        });
                        this.disabled = false;
                        this.handleClose(true);
                    } else {
                        this.disabled = false;
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                })
                .finally(() => {
                    this.showAddRecord = false;
                    this.getList();
                    loading.close();
                });
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.mini_div .el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
